<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
                <router-link to="/payable-account/new" class="btn btn-info"><i class="fa fa-plus"></i> Nova
                    despesa</router-link>
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <label for="">Descrição</label>
                            <input type="text" id="description" class="form-control"
                                placeholder="Ex: Conta a receber de xyz..." v-model="advanced_search_input.name">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Status</label>
                            <select class="form-control" v-model="advanced_search_input.status">
                                <option value="" selected>Todos os status, exceto canceladas</option>
                                <option value="Processando">Processando</option>
                                <option value="Pendente">Pendente</option>
                                <option value="Paga">Paga</option>
                                <option value="Cancelada">Cancelada</option>
                                <option value="chargedback">Chargedback</option>
                                <option value="Erro">Erro</option>
                                <option value="Em atraso">Em atraso</option>
                                <option value="Falha">Falha</option>
                            </select>
                        </div>
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Método de pagamento</label>
                            <select class="form-control" v-model="advanced_search_input.method">
                                <option value="" selected>Todos os métodos</option>
                                <option value="ticket">Apenas boletos</option>
                                <option value="pix">Apenas PIX</option>
                                <option value="Dinheiro">Apenas dinheiro</option>
                                <option value="other">Outros</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Vencimento a partir de</label>
                            <input type="date" id="from" class="form-control"
                                v-model="advanced_search_input.due_date_from">
                        </div>
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Vencimento até</label>
                            <input type="date" id="to" class="form-control" v-model="advanced_search_input.due_date_to">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Contas a pagar <small><span
                                    v-if="total_itens > 0">| Total registros encontrados: {{ formatDecimal(total_itens)
                                    }}</span></small><br>
                        </h6>
                        <div class="dropdown mb-4">
                            <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Ações
                            </button>
                            <div class="dropdown-menu animated--fade-in" aria-labelledby="dropdownMenuButton">
                                <button class="dropdown-item" @click="loadData()"><i class="fa fa-undo"></i> Recarregar
                                    dados</button>
                                <button v-if="payable_accounts.length > 0" class="dropdown-item" @click="exportPayableAccountXlsx()"><i class="fas fa-file-excel"></i> Exportar .xlsx</button>
                                <button v-if="payable_accounts.length > 0" class="dropdown-item" @click="exportPayableAccountJson()"><i
                                        class="fa fa-file"></i> Exportar .json</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Fornecedor / Documento</th>
                                        <th>Descrição</th>
                                        <th>Vencimento</th>
                                        <th class="text-center">Situação</th>
                                        <th class="text-center">Total</th>
                                        <th class="text-center">Descontos(%)</th>
                                        <th class="text-center">Multa</th>
                                        <th class="text-center">Juros(%)</th>
                                        <th class="text-center">Total a pagar</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(payable_account) in payable_accounts"
                                        :key="payable_account.id">
                                        <td class="align-middle">
                                            {{ payable_account.supplier.name }}<br>
                                            {{ payable_account.supplier.document_formatted }}
                                        </td>
                                        <td class="align-middle">
                                            <span v-if="payable_account.recurrence != ''"
                                                :tooltip="payable_account.recurrence.total_installment > 0 ? 'Cobrança parcelada: ' + payable_account.recurrence.generated_installments + ' / ' + payable_account.recurrence.total_installment : 'Cobrança recorrente: ' + payable_account.recurrence.generated_installments + 'ª Parcela'"><i
                                                    class="fa fa-undo"
                                                    v-if="payable_account.recurrence != ''"></i></span> {{
                                                        payable_account.description
                                                    }} <br> 
                                            <span class="badge badge-secondary"><span
                                                    tooltip="Categoria associada à despesa">{{
                                                        payable_account.category.name }}</span></span>
                                            <span class="badge badge-warning ml-2"><span
                                                    tooltip="Método de pagamento">{{ payable_account.method
                                                    }}</span></span>
                                            <span class="badge badge-dark ml-2"><span tooltip="Conta bancária">{{
                                                payable_account.bank.name
                                                    }}</span></span>
                                        </td>
                                        <td class="align-middle">{{ payable_account.due_date_formatted }} </td>
                                        <td class="align-middle text-center">
                                            <span class="badge " :class="badgeStatus(payable_account.status)">{{
                                                payable_account.status
                                                }}</span>
                                            <br v-if="payable_account.status == 'Paga'"><span
                                                v-if="payable_account.status == 'Paga'" class="badge badge-secondary"
                                                tooltip="Data pagamento">
                                                {{ payable_account.payment_date_formatted }}
                                            </span>
                                        </td>
                                        <td class="text-center align-middle">{{ payable_account.amount_formatted }}</td>
                                        <td class="text-center align-middle">{{ payable_account.discount_formatted }}
                                        </td>
                                        <td class="text-center align-middle">{{ payable_account.fine_formatted }}
                                        </td>
                                        <td class="text-center align-middle">{{ payable_account.interest_formatted }}
                                        </td>
                                        <td class="text-center align-middle">{{
                                            payable_account.total_payable_formatted }} </td>
                                        <td>
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false"
                                                    :disabled="(payable_account.status == 'Cancelada' && payable_account.recurrence == '') || (payable_account.status == 'Paga' && payable_account.recurrence == '')">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <button type="button" class="dropdown-item"
                                                        v-if="payable_account.status == 'Pendente' || payable_account.status == 'Em atraso'"
                                                        @click="showModalLiquidatedPayableAccount(payable_account)">Liquidar
                                                        cobrança</button>
                                                    <button type="button" class="dropdown-item"
                                                        v-if="enableEditOrDeletePayableAccount(payable_account)"
                                                        @click="showModalEditPayableAccount(payable_account)">Editar
                                                        cobrança</button>
                                                    <button type="button" class="dropdown-item"
                                                        v-if="enableEditOrDeleteRecurrencePayableAccount(payable_account)"
                                                        @click="showModalEditRecurrencePayableAccount(payable_account)">{{
                                                            title_installment }}</button>
                                                    <button type="button" class="dropdown-item"
                                                        v-if="enableEditOrDeletePayableAccount(payable_account)"
                                                        @click="deletePayableAccount(payable_account.id)">Cancelar</button>

                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="payable_accounts.length > 0 && page > 1">
                                        <td colspan="10" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="payable_accounts.length <= 0">
                                        <td colspan="10" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Atualizar cobrança-->
    <div id="modalDisplayEditPayableAccount" class="modal" :style="{ display: modalDisplayEditPayableAccount }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="modal-content border-left-primary">
                    <div class="row" v-if="enable_error_list">
                        <div class="col-xl-12 col-md-12 col-sm-12">
                            <div class="alert alert-danger">
                                <ol>
                                    <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="modal-header">
                        <h5 class="modal-title" id="newFileLabel">Atualizar despesa<br></h5>
                        <button type="button" class="close" @click="closeModalEditPayableAccount()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit="update">
                        <div class="modal-body">
                            <div class="row mt-2">
                                <div class="col-xl-8 col-md-8 col-sm-12 mt-1">
                                    <label for="">Descrição do lançamento*</label>
                                    <input type="text" class="form-control" placeholder="Pagamento referente à..."
                                        v-model="payable_account.description">
                                </div>
                                <div class="col-xl-4 col-md-6 col-sm-12 mt-1">
                                    <label for="">Data da competência*</label>
                                    <input type="date" class="form-control"
                                        v-model="payable_account.competence_date">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Valor do lançamento*</label>
                                    <input type="text" class="form-control" v-model.lazy="payable_account.amount"
                                        v-money="money">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Desconto(%)*</label>
                                    <input type="text" class="form-control" v-model.lazy="payable_account.discount"
                                        v-money="percentage">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Multa (R$)*</label>
                                    <input type="text" class="form-control" v-model.lazy="payable_account.fine"
                                        v-money="money">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Juros(% a.m)*</label>
                                    <input type="text" class="form-control" v-model.lazy="payable_account.interest"
                                        v-money="percentage">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-4 col-sm-4 col-xs-12">
                                    <label for="">Categoria*</label>
                                    <multiselect v-model="category_multiselect" :options="categories_options"
                                        :custom-label="categoryWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectCategory">

                                        <template #noResult>
                                            Nenhuma categoria encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-4 col-sm-4 col-xs-12">
                                    <label for="">Vencimento*</label>
                                    <input type="date" class="form-control" v-model="payable_account.due_date">
                                </div>
                                <div class="col-lg-4 col-sm-4 col-xs-12">
                                    <label for="">Código de referência</label>
                                    <input type="text" class="form-control" placeholder="Ex: 0001"
                                        v-model="payable_account.cod_reference">
                                </div>
                            </div>
                            <div class="row mt-2 mb-4">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText :modelValue="payable_account.observation"
                                        @update-text="updateObservation" placeholderSend="Sem observações"
                                        ref="observations_payable_account">
                                    </editorText>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalEditPayableAccount()"><i
                                    class="fa fa-ban"></i>
                                Fechar</button>
                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                    class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!--Atualizar recorrência-->
    <div id="modalDisplayEditRecurrencePayableAccount" class="modal"
        :style="{ display: modalDisplayEditRecurrencePayableAccount }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="modal-content border-left-primary">
                    <div class="row" v-if="enable_error_list">
                        <div class="col-xl-12 col-md-12 col-sm-12">
                            <div class="alert alert-danger">
                                <ol>
                                    <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="modal-header">
                        <h5 class="modal-title" id="newFileLabel">{{ title_installment }}<br>
                            <span class="badge badge-danger"
                                v-if="payable_account.status == 'Finalizada'">Finalizada</span>
                            <span class="badge badge-success" v-if="payable_account.status == 'Ativa'">Ativa</span>
                        </h5>
                        <button type="button" class="close" @click="closeModalEditRecurrencePayableAccount()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit="updateRecurrence">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-sm-12 mt-1">
                                    <label for="">Descrição do lançamento*</label>
                                    <input type="text" class="form-control" placeholder="Pagamento referente à..."
                                        v-model="payable_account.description">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Valor do lançamento*</label>
                                    <input type="text" class="form-control" v-model.lazy="payable_account.amount"
                                        v-money="money">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Desconto(%)*</label>
                                    <input type="text" class="form-control" v-model.lazy="payable_account.discount"
                                        v-money="percentage">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Multa (R$)*</label>
                                    <input type="text" class="form-control" v-model.lazy="payable_account.fine"
                                        v-money="money">
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                    <label for="">Juros(% a.m)*</label>
                                    <input type="text" class="form-control" v-model.lazy="payable_account.interest"
                                        v-money="percentage">
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col-lg-6 col-sm-6 col-xs-12">
                                    <label for="">Categoria*</label>
                                    <multiselect v-model="category_multiselect" :options="categories_options"
                                        :custom-label="categoryWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectCategory">

                                        <template #noResult>
                                            Nenhuma categoria encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-6 col-sm-6 col-xs-12">
                                    <label for="">Código de referência</label>
                                    <input type="text" class="form-control" placeholder="Ex: 0001"
                                        v-model="payable_account.cod_reference">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1" v-if="payable_account.repeat">
                                    <label for="">Cobrar sempre no*</label>
                                    <multiselect v-model="day_generate_receivable_multiselect"
                                        :options="day_generate_receivable_options" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        :custom-label="dayGeneratePayableWithLang"
                                        @select="handleSelectDayGeneratePayable">
                                        <template #noResult>
                                            Nenhum dia encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1" v-if="!payable_account.repeat">
                                    <label for="">Parcelamento*</label>
                                    <multiselect v-model="installment_multiselect" :options="installments_options"
                                        placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                        :deselect-label="'Clique para remover'" :custom-label="installmentWithLang"
                                        @select="handleSelectInstallment">
                                        <template #noResult>
                                            Nenhum parcelamento encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1"
                                    v-if="payable_account.installment > 1 || payable_account.repeat">
                                    <label for="">Intervalo entre parcelas*</label>
                                    <multiselect v-model="interval_recurrence_multiselect"
                                        :options="interval_recurrence_options" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        :custom-label="intervalRecurrenceWithLang"
                                        @select="handleSelectIntervalRecurrence">
                                        <template #noResult>
                                            Nenhum intervalo encontrado.
                                        </template>
                                    </multiselect>

                                </div>
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1">
                                    <label for="">Forma de pagamento*</label>
                                    <multiselect v-model="method_multiselect" :options="methods_options"
                                        :custom-label="methodWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectMethod">

                                        <template #noResult>
                                            Nenhuma forma de pagamento encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-md-6 col-xl-6 col-sm-12 mt-1">
                                    <label for="">Conta de pagamento*</label>
                                    <multiselect v-model="bank_multiselect" :options="banks_options"
                                        :custom-label="bankWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectBank">

                                        <template #noResult>
                                            Nenhuma conta encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                            <div class="row mt-2 mb-4">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText :modelValue="payable_account.observation"
                                        @update-text="updateObservation" placeholderSend="Sem observações"
                                        ref="observations_recurrence_payable_account">
                                    </editorText>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalEditRecurrencePayableAccount()"><i class="fa fa-ban"></i>
                                Fechar</button>
                            <button type="submit" :disabled='!isDisabledRecurrence' class="btn btn-info"><i
                                    class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div id="modalDisplayLiquidatedPayableAccount" class="modal"
        :style="{ display: modalDisplayLiquidatedPayableAccount }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="liquidatedPayableAccount">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Liquidar cobrança<br>
                                <span class="badge badge-info mt-1">Fornecedor: {{ payable_account.supplier_name }} - {{ payable_account.supplier_document }}</span>
                                <span class="ml-2 mt-1 badge" :class="payable_account.status == 'Em atraso'?'badge-danger':'badge-warning'">Situação: {{ payable_account.status }}</span>
                            </h5>
                            <button type="button" class="close" @click="closeModalLiquidatedPayableAccount()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xl-8 col-md-8 col-sm-12 mt-1">
                                    <label for="">Descrição do lançamento*</label>
                                    <input type="text" class="form-control" placeholder="Pagamento referente à..."
                                        v-model="payable_account.description">
                                </div>
                                 <div class="col-xl-4 col-md-4 col-sm-12 mt-1">
                                    <label for="">Data do pagamento*</label>
                                    <input type="date" class="form-control"
                                        v-model="payable_account.payment_date">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-xl-4 col-sm-12 mt-1">
                                    <label for="">Valor do lançamento*</label>
                                    <input type="text" class="form-control" v-model.lazy="payable_account.amount"
                                        v-money="money">
                                </div>
                                <div class="col-md-4 col-xl-4 col-sm-12 mt-1">
                                    <label for="">Forma de pagamento*</label>
                                    <multiselect v-model="method_multiselect" :options="methods_options"
                                        :custom-label="methodWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectMethod">

                                        <template #noResult>
                                            Nenhuma forma de pagamento encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-md-4 col-xl-4 col-sm-12 mt-1">
                                    <label for="">Conta de pagamento*</label>
                                    <multiselect v-model="bank_multiselect" :options="banks_options"
                                        :custom-label="bankWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectBank">
                                        <template #noResult>
                                            Nenhuma conta encontrada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                             <div class="row mt-2">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    Comprovante <small>(Tamanho máximo: 5MB)</small>
                                    <input type="file" @change="handleFileChange">
                                </div>
                            </div>
                            <div class="row mt-3" v-if="payable_account.size != ''">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small class="mt-5">Tamanho arquivo selecionado: {{ payable_account.size }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalLiquidatedPayableAccount()"><i class="fa fa-ban"></i>
                                Cancelar</button>
                            <button type="submit" class="btn btn-info"
                                :disabled='!isDisabledLiquidatedPayableAccount'><i class="fa fa-check"></i>
                                Liquidar cobrança</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>
<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import editorText from '../util/editor-text.vue';
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import Multiselect from 'vue-multiselect'

import 'vue-loading-overlay/dist/css/index.css';
import { capitalize } from '@/util';

export default {
    directives: { money: VMoney, mask },
    components: { Loading, editorText, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: { status: '', method: '' },
            payable_accounts: [],
            url_api: '',
            method_multiselect: '',
            category_multiselect: '',
            bank_multiselect: '',
            categories_options: [],
            banks_options: [],
            day_generate_receivable_multiselect: { type: '1', value: '1º dia do mês' },
            installment_multiselect: { type: '1', value: 'À vista' },
            interval_recurrence_multiselect: { type: 'monthly', value: 'Mensal' },
            page: 1,
            last_page: 1,
            total_itens: 0,
            title_installment: 'Editar recorrência',
            modalDisplayEditPayableAccount: 'none',
            modalDisplayEditRecurrencePayableAccount: 'none',
            modalDisplayLiquidatedPayableAccount: 'none',
            enable_error_list: false,
            errors: [],
            payable_account: {
                id: '',
                category_id: '',
                competence_date: '',
                description: '',
                amount: '',
                discount: '',
                fine: '',
                interest: '',
                cod_reference: '',
                due_date: '',
                observation: '',
                interval_recurrence: 'monthly',
                day_generate_receivable: 1,
                repeat: false,
                method: '',
                installment: 1,
                bank_id: '',
                status: '',
                payment_date: '',
                size:'',
                archive: null,
                supplier_name:'',
                supplier_document:'',
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            percentage: {
                decimal: '.',
                thousands: '',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            day_generate_receivable_options: [
                { type: 1, value: '1º dia do mês' },
                { type: 2, value: '2º dia do mês' },
                { type: 3, value: '3º dia do mês' },
                { type: 4, value: '4º dia do mês' },
                { type: 5, value: '5º dia do mês' },
                { type: 6, value: '6º dia do mês' },
                { type: 7, value: '7º dia do mês' },
                { type: 8, value: '8º dia do mês' },
                { type: 9, value: '9º dia do mês' },
                { type: 10, value: '10º dia do mês' },
                { type: 11, value: '11º dia do mês' },
                { type: 12, value: '12º dia do mês' },
                { type: 13, value: '13º dia do mês' },
                { type: 14, value: '14º dia do mês' },
                { type: 15, value: '15º dia do mês' },
                { type: 16, value: '16º dia do mês' },
                { type: 17, value: '17º dia do mês' },
                { type: 18, value: '18º dia do mês' },
                { type: 19, value: '19º dia do mês' },
                { type: 20, value: '20º dia do mês' },
                { type: 21, value: '21º dia do mês' },
                { type: 22, value: '22º dia do mês' },
                { type: 23, value: '23º dia do mês' },
                { type: 24, value: '24º dia do mês' },
                { type: 25, value: '25º dia do mês' },
                { type: 26, value: '26º dia do mês' },
                { type: 27, value: '27º dia do mês' },
                { type: 28, value: '28º dia do mês' },

            ],
            installments_options: [
                { type: 1, value: 'À vista' },
                { type: 2, value: '2x' },
                { type: 3, value: '3x' },
                { type: 4, value: '4x' },
                { type: 5, value: '5x' },
                { type: 6, value: '6x' },
                { type: 7, value: '7x' },
                { type: 8, value: '8x' },
                { type: 9, value: '9x' },
                { type: 10, value: '10x' },
                { type: 11, value: '11x' },
                { type: 12, value: '12x' },
            ],
            methods_options: [
                { type: 'pix', value: 'PIX' },
                { type: 'ticket', value: 'Boleto' },
                { type: 'money', value: 'Dinheiro' },
                { type: 'other', value: 'Outros' }
            ],
            interval_recurrence_options: [
                { type: 'monthly', value: 'Mensal' },
                { type: 'bimonthly', value: 'Bimestral' },
                { type: 'quarterly', value: 'Trimestral' },
                { type: 'semiannual', value: 'Semestral' },
                { type: 'annual', value: 'Anual' }
            ],
        }
    },
    computed: {
        isDisabled: function () {
            return this.payable_account.description != '' && this.payable_account.competence_date != '' && this.payable_account.amount != '' && this.payable_account.category_id != '' && this.payable_account.due_date != '';
        },
        isDisabledRecurrence: function () {
            if (this.payable_account.status == 'Finalizada') {
                return false;
            }
            return this.payable_account.description != '' && this.payable_account.amount != '' && this.payable_account.category_id != '';
        },
        isDisabledLiquidatedPayableAccount: function () {
            return this.payable_account.description != '' && this.payable_account.amount != '' && this.payable_account.bank_id != '' &&  this.payable_account.payment_date != '';
        },
        buttonPagination: function () {
            return this.page > 1;
        },
        badgeStatus() {
            return (status) => {
                if (status == 'Processando') {
                    return 'badge-warning'
                } else if (status == 'Pendente') {
                    return 'badge-info'
                } else if (status == 'Paga') {
                    return 'badge-success'
                } else if (status == 'Cancelada') {
                    return 'badge-danger'
                } else if (status == 'Cancelando') {
                    return 'badge-danger'
                } else if (status == 'chargedback') {
                    return 'badge-danger'
                } else if (status == 'Erro') {
                    return 'badge-danger'
                } else if (status == 'Em atraso') {
                    return 'badge-danger'
                } else if (status == 'Falha') {
                    return 'badge-danger'
                } else if (status == 'Negada') {
                    return 'badge-danger'
                }
                return 'badge-secondary'
            }
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        updateObservation(observation) {
            this.payable_account.observation = observation;
        },
        bankWithLang({ value }) {
            return value;
        },
        categoryWithLang({ value }) {
            return value;
        },
        handleSelectBank(option) {
            this.payable_account.bank_id = option.key;

        },
        handleSelectCategory(option) {
            this.payable_account.category_id = option.key;
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.payable_accounts = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.payable_accounts = {}
            this.advanced_search_input = {}
            this.loadData();
        },

        viewTicket(id) {
            const url = process.env.VUE_APP_URL_API + '/payment-ticket/' + id + '/downloadFile';
            window.open(url, '_blank');
        },

        copyDigitableLine(payment) {
            window.navigator.clipboard.writeText(payment.data.code);
            this.$notify({
                title: "Sucesso",
                text: "Linha digitável copiada com sucesso!",
                type: 'success'
            });
        },

        viewPix(id) {
            const url = process.env.VUE_APP_URL_API + '/payment-pix/' + id + '/viewPix';
            window.open(url, '_blank');
        },

        copyKeyCopyPaste(payment) {
            window.navigator.clipboard.writeText(payment.data.key);
            this.$notify({
                title: "Sucesso",
                text: "Chave Copia e Cola copiada com sucesso!",
                type: 'success'
            });
        },
          handleFileChange(event) {
            if (event.target.files[0] != undefined) {
                const sizeInBytes = event.target.files[0].size;
                const sizeInMB = sizeInBytes / (1024 * 1024);
                if (sizeInMB > 5) {
                    this.$notify({
                        title: "Informação",
                        text: "Seu arquivo excede o limite de envio. O máximo para envio são 5MB",
                        type: 'info'
                    });
                    this.payable_account.archive = null;
                } else {
                    this.payable_account.archive = event.target.files[0];
                }
                this.payable_account.size = sizeInMB.toFixed(2) + 'MB';

            } else {
                this.payable_account.size = '';
                this.payable_account.archive = null;
            }

        },
        async getCategories() {
            this.isLoading = true;
            const response = api.get('/category')
                .then((response) => {
                    this.categories = response.data.data;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
        async getBank() {
            this.isLoading = true;
            this.isLoading = true;
            const response = api.get('/bank-account')
                .then((response) => {
                    this.banks = response.data.data;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
        methodWithLang({ value }) {
            return value;
        },

        dayGeneratePayableWithLang({ value }) {
            return value;
        },
        installmentWithLang({ value }) {
            return value;
        },
        intervalRecurrenceWithLang({ value }) {
            return value;
        },

        handleSelectMethod(option) {
            this.payable_account.method = option.type;
        },
        handleSelectDayGeneratePayable(option) {
            this.payable_account.day_generate_receivable = option.type;
        },
        handleSelectInstallment(option) {
            this.payable_account.total_installment = option.type;

        },
        handleSelectIntervalRecurrence(option) {
            this.payable_account.interval_recurrence = option.type;
        },

        formatDecimal(number) {
            return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;

            api.get('/payable-account', {
                params: {
                    'name': this.advanced_search_input.name,
                    'status': this.advanced_search_input.status,
                    'method': this.advanced_search_input.method,
                    'due_date_from': this.advanced_search_input.due_date_from,
                    'due_date_to': this.advanced_search_input.due_date_to,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.payable_accounts = response.data.data;
                    } else {
                        this.payable_accounts = this.payable_accounts.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },
        update(event) {
            event.preventDefault();
            this.$confirm(
                {
                    message: 'Deseja confirmar a atualização da despesa?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.put('/payable-account/' + this.payable_account.id, this.payable_account)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Despesa atualizada com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.closeModalEditPayableAccount();
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    if (error.status == 422) {
                                        let response_errors = error.response.data.errors;
                                        this.errors = response_errors;
                                        this.enable_error_list = true;
                                    }
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        updateRecurrence(event) {
            event.preventDefault();
            this.$confirm(
                {
                    message: this.payable_account.total_installment > 0 ? 'Deseja atualizar a parcela?' : 'Deseja atualizar a recorrência?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/payable-account/' + this.payable_account.id + '/recurrence', this.payable_account)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: this.payable_account.total_installment > 0 ? "Parcelamento atualizado com sucesso" : "Recorrência atualizada com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.closeModalEditRecurrencePayableAccount();
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    if (error.status == 422) {
                                        let response_errors = error.response.data.errors;
                                        this.errors = response_errors;
                                        this.enable_error_list = true;
                                    }
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        liquidatedPayableAccount(event) {
            event.preventDefault();
            this.$confirm(
                {
                    message: 'Confirma a liquidação da cobrança? Nota: uma vez liquidada, a cobrança em questão não pode ser revertida.',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            const formData = new FormData();
                            formData.append('payment_date', this.payable_account.payment_date);
                            formData.append('bank_id', this.payable_account.bank_id);
                            formData.append('amount', this.payable_account.amount);
                            formData.append('method', this.payable_account.method);
                            if (this.payable_account.archive != null) {
                                formData.append('file', this.payable_account.archive);
                            }
                            api.post('/payable-account/' + this.payable_account.id + '/manualPayableAccountLiquidated', formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                }
                            })
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Cobrança liquidada com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.closeModalLiquidatedPayableAccount();
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    if (error.status == 422) {
                                        let response_errors = error.response.data.errors;
                                        this.errors = response_errors;
                                        this.enable_error_list = true;
                                    }
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        deletePayableAccount(id) {
            this.$confirm(
                {
                    message: 'Deseja cancelar a cobrança? Nota: uma vez removida, não é possível reverter a ação.',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/payable-account/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Despesa removida com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        enableEditOrDeletePayableAccount(payable_account) {
            let enable = true;
            if (payable_account.status == 'Erro'
                || payable_account.status == 'Falha'
                || payable_account.status == 'Paga'
                || payable_account.status == 'Cancelada'
                || payable_account.status == 'expired') {
                enable = false;
            }
            return enable;
        },
        enableEditOrDeleteRecurrencePayableAccount(payable_account) {
            let enable = true;
            if (payable_account.status == 'Erro'
                || payable_account.status == 'Falha'
                || payable_account.status == 'expired') {
                enable = false;
            } else if (payable_account.recurrence == '') {
                enable = false;
            }

            let recurrence = payable_account.recurrence;
            if (recurrence.total_installment > 0) {
                this.title_installment = 'Editar parcelamento';
            } else {
                this.title_installment = 'Editar recorrência';
            }
            return enable;
        },
        showModalEditPayableAccount(payable_account) {
            this.payable_account.id = payable_account.id;
            this.payable_account.category_id = payable_account.category.id;
            this.payable_account.competence_date = payable_account.competence_date;
            this.payable_account.description = payable_account.description;
            this.payable_account.amount = payable_account.total_payable_formatted;
            this.payable_account.discount = payable_account.discount;
            this.payable_account.fine = payable_account.fine_formatted;
            this.payable_account.interest = payable_account.interest;
            this.payable_account.cod_reference = payable_account.cod_reference;
            this.payable_account.due_date = payable_account.due_date;
            this.payable_account.observation = payable_account.observation;
            this.$refs.observations_payable_account.updateTextEditor(payable_account.observation);
            this.category_multiselect = { 'key': payable_account.category.id, 'value': payable_account.category.name };
            this.modalDisplayEditPayableAccount = 'block';
        },

        showModalEditRecurrencePayableAccount(payable_account) {
            let recurrence = payable_account.recurrence;
            this.payable_account.id = recurrence.id;
            this.payable_account.category_id = recurrence.category.id;
            this.payable_account.description = recurrence.description;
            this.payable_account.amount = recurrence.amount_formatted;
            this.payable_account.discount = recurrence.discount;
            this.payable_account.fine = recurrence.fine_formatted;
            this.payable_account.interest = recurrence.interest;
            this.payable_account.cod_reference = recurrence.cod_reference;
            this.payable_account.total_installment = recurrence.total_installment;
            this.payable_account.method = recurrence.method;
            this.payable_account.interval_recurrence = recurrence.interval_recurrence;
            this.payable_account.day_generate_receivable = recurrence.day_generate_receivable;
            this.installment_multiselect = { type: recurrence.total_installment, value: recurrence.total_installment == 1 ? 'À vista' : recurrence.total_installment + 'x' }
            this.payable_account.observation = recurrence.observation;
            this.payable_account.status = recurrence.status;
            this.$refs.observations_recurrence_payable_account.updateTextEditor(recurrence.observation);
            this.category_multiselect = { 'key': recurrence.category.id, 'value': recurrence.category.name };
            if (recurrence.interval_recurrence == 'monthly') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Mensal' };
            } else if (recurrence.interval_recurrence == 'bimonthly') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Bimestral' };
            } else if (recurrence.interval_recurrence == 'quarterly') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Trimestral' };
            } else if (recurrence.interval_recurrence == 'semiannual') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Semestral' };
            } else if (recurrence.interval_recurrence == 'annual') {
                this.interval_recurrence_multiselect = { type: recurrence.interval_recurrence, value: 'Anual' };
            }

            if (recurrence.method == 'pix') {
                this.method_multiselect = { type: recurrence.method, value: 'PIX' }
            } else if (recurrence.method == 'ticket') {
                this.method_multiselect = { type: recurrence.method, value: 'Boleto' }
            } else if (recurrence.method == 'money') {
                this.method_multiselect = { type: recurrence.method, value: 'Dinheiro' }
            } else if (recurrence.method == 'other') {
                this.method_multiselect = { type: recurrence.method, value: 'Outros' }
            }

            this.bank_multiselect = { key: recurrence.bank.id, value: 'Conta: ' + capitalize(recurrence.bank.name) }

            if (recurrence.total_installment <= 0) {
                this.payable_account.repeat = true;
                this.day_generate_receivable_multiselect = { type: recurrence.day_generate_receivable, value: recurrence.day_generate_receivable + 'º dia do mês' }
            } else if (recurrence.total_installment) {
                this.payable_account.repeat = false;
            }
            this.modalDisplayEditRecurrencePayableAccount = 'block';
        },

        showModalLiquidatedPayableAccount(payable_account) {
            this.payable_account.id = payable_account.id;
            this.payable_account.description = payable_account.description;
            this.payable_account.amount = payable_account.total_payable_formatted;
            this.payable_account.bank_id = payable_account.bank.id;
            this.payable_account.status = payable_account.status;
            this.payable_account.supplier_name = payable_account.supplier.name;
            this.payable_account.supplier_document = payable_account.supplier.document_formatted;
          
            this.bank_multiselect = { key: payable_account.bank.id, value: 'Conta: ' + capitalize(payable_account.bank.name) }
            if (payable_account.method == 'pix') {
                this.method_multiselect = { type: payable_account.method, value: 'PIX' }
            } else if (payable_account.method == 'Boleto') {
                this.method_multiselect = { type: payable_account.method, value: 'Boleto' }
            } else if (payable_account.method == 'Dinheiro') {
                this.method_multiselect = { type: payable_account.method, value: 'Dinheiro' }
            } else if (payable_account.method == 'Outros') {
                this.method_multiselect = { type: payable_account.method, value: 'Outros' }
            }
              this.payable_account.method = payable_account.method_original;
            
            this.modalDisplayLiquidatedPayableAccount = 'block';
        },

        closeModalEditPayableAccount() {
            this.payable_account = {};
            this.errors = [];
            this.enable_error_list = false;
            this.$refs.observations_payable_account.updateTextEditor('');
            this.modalDisplayEditPayableAccount = 'none';
        },

        closeModalEditRecurrencePayableAccount() {
            this.payable_account = {};
            this.errors = [];
            this.enable_error_list = false;
            this.$refs.observations_payable_account.updateTextEditor('');
            this.modalDisplayEditRecurrencePayableAccount = 'none';
        },

        closeModalLiquidatedPayableAccount() {
            this.payable_account = {};
            this.modalDisplayLiquidatedPayableAccount = 'none';
        },

         generateRandom() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },

         downloadFile(receipt_id) {
            this.isLoading = true;
            api.get('/payable-account/' + receipt_id + '/download', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    link.download = 'download_' + this.generateRandom();
                    link.click()
                    URL.revokeObjectURL(link.href);
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

          async exportPayableAccountXlsx() {
            this.isLoading = true;

            api.get('/payable-account-export', {
                responseType: 'blob', params: {
                    'name': this.advanced_search_input.name,
                    'status': this.advanced_search_input.status,
                    'method': this.advanced_search_input.method,
                    'due_date_from': this.advanced_search_input.due_date_from,
                    'due_date_to': this.advanced_search_input.due_date_to,
                    'page': this.page
                }
            })
                .then((response) => {

                    this.isLoading = false;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'despesas.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        async exportPayableAccountJson() {
            this.isLoading = true;

            api.get('/payable-account-export', {
                params: {
                    'name': this.advanced_search_input.name,
                    'status': this.advanced_search_input.status,
                    'method': this.advanced_search_input.method,
                    'due_date_from': this.advanced_search_input.due_date_from,
                    'due_date_to': this.advanced_search_input.due_date_to,
                    'page': this.page,
                    'type_export': 'json'
                },
                headers: {
                    'Accept': 'application/json; charset=UTF-8',
                    'charset': 'utf-8'
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    const url = window.URL.createObjectURL(new Blob([response.data.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'despesas.json');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                  
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },


    },

    mounted() {
        this.url_api = process.env.VUE_APP_URL_API
        this.loadData();
        const response_categories = this.getCategories();
        const response_banks = this.getBank();
        response_categories.then(() => {
            this.categories_options = this.categories.map(item => ({
                key: item.id,
                value: item.name
            }));

        });
        response_banks.then(() => {
            this.banks_options = this.banks.map(item => ({

                key: item.id,
                value: 'Conta: ' + capitalize(item.name)
            }));
        });

    },
}
</script>

<style>

body {
    margin: 0;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: sans-serif;
    background: #ededed;
}

main {
    flex: 1 1 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

aside {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #49b293;
    color: #fff;
    padding: 1em;
}

main div {
    text-align: center;
    color: #353539;
}

main span {
    padding: .5em 1em;
    margin: .5em;
    display: inline-block;
    background: #dedede;
}

aside a {
    color: inherit;
    text-decoration: none;
    font-weight: bold;
    display: inline-block;
    padding: .4em 1em;
}

td,
th,
tr {
    vertical-align: middle;
}
</style>